import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/library/icons/basic-shape-hexagon.svg
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 256 256"
};
function render(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "m223.68 66.15-88-48.15a15.88 15.88 0 0 0-15.36 0l-88 48.17a16 16 0 0 0-8.32 14v95.64a16 16 0 0 0 8.32 14l88 48.17a15.88 15.88 0 0 0 15.36 0l88-48.17a16 16 0 0 0 8.32-14V80.18a16 16 0 0 0-8.32-14.03M216 175.82 128 224l-88-48.18V80.18L128 32l88 48.17Z" }, null, -1)])]);
}
var basic_shape_hexagon_default = { render };
//#endregion
export { basic_shape_hexagon_default as default, render };

//# sourceMappingURL=basic-shape-hexagon.svg.js.map